const no = {
  // ============================================================
  // COMMON — Delt på tvers av hele applikasjonen
  // ============================================================
  common: {
    loading: 'Laster...',
    error: 'Feil',
    save: 'Lagre',
    cancel: 'Avbryt',
    delete: 'Slett',
    edit: 'Rediger',
    create: 'Opprett',
    add: 'Legg til',
    remove: 'Fjern',
    close: 'Lukk',
    confirm: 'Bekreft',
    apply: 'Bruk',
    reset: 'Tilbakestill',
    search: 'Søk',
    filter: 'Filtrer',
    clear: 'Tøm',
    back: 'Tilbake',
    next: 'Neste',
    previous: 'Forrige',
    submit: 'Send inn',
    update: 'Oppdater',
    refresh: 'Oppdater',
    export: 'Eksporter',
    import: 'Importer',
    download: 'Last ned',
    upload: 'Last opp',
    print: 'Skriv ut',
    copy: 'Kopier',
    yes: 'Ja',
    no: 'Nei',
    ok: 'OK',
    done: 'Ferdig',
    select: 'Velg',
    selectAll: 'Velg Alle',
    deselectAll: 'Fjern Alle Valg',
    noResults: 'Ingen resultater funnet',
    noData: 'Ingen data tilgjengelig',
    required: 'Påkrevd',
    optional: 'Valgfri',
    actions: 'Handlinger',
    details: 'Detaljer',
    overview: 'Oversikt',
    summary: 'Sammendrag',
    total: 'Totalt',
    all: 'Alle',
    none: 'Ingen',
    name: 'Navn',
    type: 'Type',
    status: 'Status',
    date: 'Dato',
    time: 'Tid',
    description: 'Beskrivelse',
    notes: 'Notater',
    comments: 'Kommentarer',
    category: 'Kategori',
    priority: 'Prioritet',
    nation: 'Nasjon',
    country: 'Land',
    email: 'E-post',
    phone: 'Telefon',
    address: 'Adresse',
    location: 'Plassering',
    coordinates: 'Koordinater',
    latitude: 'Breddegrad',
    longitude: 'Lengdegrad',
    from: 'Fra',
    to: 'Til',
    createdAt: 'Opprettet',
    updatedAt: 'Oppdatert',
    createdBy: 'Opprettet av',
    modifiedBy: 'Endret av',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    enabled: 'Aktivert',
    disabled: 'Deaktivert',
    showing: 'Viser',
    of: 'av',
    page: 'Side',
    perPage: 'per side',
    rows: 'rader',
    items: 'elementer',
    results: 'resultater',
    sortBy: 'Sorter etter',
    ascending: 'Stigende',
    descending: 'Synkende',
    viewAll: 'Se Alle',
    viewDetails: 'Se Detaljer',
    goBack: 'Gå Tilbake',
    learnMore: 'Les Mer',
    seeMore: 'Se Mer',
    showMore: 'Vis Mer',
    showLess: 'Vis Mindre',
    expandAll: 'Utvid Alle',
    collapseAll: 'Skjul Alle',
    copied: 'Kopiert!',
    saved: 'Lagret!',
    deleted: 'Slettet!',
    updated: 'Oppdatert!',
    created: 'Opprettet!',
    success: 'Suksess',
    warning: 'Advarsel',
    info: 'Informasjon',
    danger: 'Fare',
    unknown: 'Ukjent',
    notAvailable: 'I/T',
    never: 'Aldri',
    today: 'I dag',
    yesterday: 'I går',
    tomorrow: 'I morgen',
    now: 'Nå',
    ago: 'siden',
    justNow: 'akkurat nå',
    minutesAgo: '{{count}}m siden',
    hoursAgo: '{{count}}t siden',
    daysAgo: '{{count}}d siden',
    monthsAgo: '{{count}}mnd siden',
    id: 'ID',
    version: 'Versjon',
    language: 'Språk',
    theme: 'Tema',
    darkMode: 'Mørk Modus',
    lightMode: 'Lys Modus',
    failedToLoad: 'Kunne ikke laste data',
    failedToSave: 'Kunne ikke lagre',
    failedToDelete: 'Kunne ikke slette',
    failedToUpdate: 'Kunne ikke oppdatere',
    confirmDelete: 'Er du sikker på at du vil slette dette?',
    confirmAction: 'Er du sikker?',
    unsavedChanges: 'Du har ulagrede endringer. Er du sikker på at du vil forlate siden?',
    pageNotFound: '404 - Side Ikke Funnet',
    pageNotFoundDesc: 'Siden du leter etter finnes ikke.',
    backToDashboard: 'Tilbake til Dashboard',
    characters: 'tegn',
    maxCharacters: 'Maksimalt {{max}} tegn',
    remaining: '{{count}} gjenstående',
    selected: '{{count}} valgt',
    of_total: '{{count}} av {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Topplinje, sidefelt, menyer
  // ============================================================
  nav: {
    dashboard: 'Dashboard',
    requests: 'Forespørsler',
    transports: 'Transporter',
    myPatients: 'Mine Pasienter',
    statistics: 'Statistikk',
    flow: 'Flyt',
    resources: 'Resources',
    exercise: 'Øvelse',
    administration: 'Administrasjon',
    map: 'Kart',
    info: 'Informasjon',
    users: 'Brukere',
    assets: 'Ressurser',
    hubs: 'Hubber',
    treatmentFacilities: 'Behandlingsinstitusjoner',
    patientImport: 'Pasientimport',
    assetTemplates: 'Ressursmaler',
    dayTemplates: 'Dagsmaler',
    announcementTicker: 'Kunngjøringslinje',
    exerciseStatistics: 'Øvelsesstatistikk',
    settings: 'Innstillinger',
    auditLog: 'Revisjonslogg',
    exerciseControl: 'Øvelsesstyring',
    dataSync: 'Datasynkronisering',
    documentation: 'Dokumentasjon',
    support: 'Brukerstøtte',
    about: 'Om',
    assetContracts: 'Asset Contracts',
    notifications: 'Varsler',
    schedules: 'Ruteplaner',
    capacityPlanning: 'Kapasitetsplanlegging',
    transportPlanning: 'Transportplanlegging',
    transportBooking: 'Transportbooking',
    flowDiagram: 'Flytdiagram',
    changePassword: 'Endre Passord',
    missions: 'Oppdrag',
    startPoints: 'Startpunkter',
    hospital: 'Sykehus',
  },

  // ============================================================
  // AUTH — Innlogging, passord, sesjon
  // ============================================================
  auth: {
    login: 'Logg inn',
    logout: 'Logg ut',
    logoutNow: 'Logg Ut Nå',
    loggingIn: 'Logger inn...',
    loginFailed: 'Innlogging mislyktes',
    email: 'E-post',
    password: 'Passord',
    username: 'Brukernavn',
    enterEmail: 'Skriv inn e-postadressen din',
    enterPassword: 'Skriv inn passordet ditt',
    enterUsername: 'Skriv inn brukernavnet ditt',
    forgotPassword: 'Glemt passord?',
    forgotPasswordTitle: 'Glemt Passord',
    forgotPasswordDesc: 'Skriv inn brukernavnet og e-postadressen din. Hvis begge stemmer, vil administratorene bli varslet for å tilbakestille passordet ditt.',
    requestPasswordReset: 'Be om Tilbakestilling av Passord',
    sending: 'Sender...',
    backToLogin: 'Tilbake til Innlogging',
    pleaseWait: 'Vennligst vent før du prøver igjen.',
    requestFailed: 'Forespørsel mislyktes',
    credentialsMatch: 'Hvis legitimasjonen stemmer, har administratorene blitt varslet.',
    forAccess: 'For tilgang, vennligst kontakt systemadministratoren din.',
    changePassword: 'Endre Passord',
    currentPassword: 'Nåværende Passord',
    newPassword: 'Nytt Passord',
    confirmPassword: 'Bekreft Passord',
    passwordChanged: 'Passord endret vellykket',
    passwordMismatch: 'Passordene stemmer ikke overens',
    passwordTooShort: 'Passordet må være minst 8 tegn',
    changingPassword: 'Endrer...',
    mustChangePassword: 'Du må endre passordet ditt før du kan fortsette.',
    sessionExpiring: 'Sesjonen Utløper',
    sessionExpireText: 'Sesjonen din utløper om <strong>{{time}}</strong>. Vennligst lagre arbeidet ditt og logg inn igjen for å fortsette.',
    dismiss: 'Avvis',
    switchNation: 'Bytt Nasjon',
    returnTo: 'Gå tilbake til {{nation}}',
    viewingAs: 'Du ser som',
    loggedInAs: 'logget inn som {{nation}}',
    trainingMode: 'KUN FOR TRENINGSFORMÅL',
    dedication: 'Skapt med kjærlighet og dedikasjon til profesjonen',
  },

  // ============================================================
  // ROLES — Brukerroller og etiketter
  // ============================================================
  roles: {
    admin: 'Systemadministrator',
    excon: 'Øvelseskontrollør',
    eu: 'EU-koordinator',
    planner: 'Planlegger',
    hub: 'Hub-ansvarlig',
    nation: 'Nasjon',
    readOnly: 'Skrivebeskyttet',
    systemAdmin: 'Systemadministrator',
    transportPlanner: 'Transportplanlegger',
    systemRoles: 'Systemroller',
  },

  // ============================================================
  // STATUS — Forespørsels-, tilbuds-, oppdragsstatus
  // ============================================================
  status: {
    draft: 'Utkast',
    underReview: 'Under Gjennomgang',
    published: 'Publisert',
    underSelection: 'Under Utvelgelse',
    accepted: 'Akseptert',
    planned: 'Planlagt',
    inTransit: 'Under Transport',
    completed: 'Fullført',
    closed: 'Lukket',
    withdrawn: 'Trukket Tilbake',
    pending: 'Venter',
    rejected: 'Avvist',
    cancelled: 'Avlyst',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    review: 'Gjennomgang',
    selection: 'Utvelgelse',
    transit: 'Transport',
  },

  // ============================================================
  // CATEGORIES — Forespørselskategorier
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personell',
    material: 'Materiell',
    equipment: 'Utstyr',
    other: 'Annet',
    news: 'Nyheter',
  },

  // ============================================================
  // URGENCY — Hastenivåer
  // ============================================================
  urgency: {
    routine: 'Rutine',
    priority: 'Prioritet',
    urgent: 'Haster',
    immediate: 'Umiddelbar',
  },

  // ============================================================
  // ASSETS — Transportressurstyper
  // ============================================================
  assetTypes: {
    train: 'Tog',
    ship: 'Skip',
    aircraft: 'Fly',
    bus: 'Buss',
    ambulance: 'Ambulanse',
    drone: 'Drone',
    helicopter: 'Helikopter',
    ferry: 'Ferge',
    other: 'Annet',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Dashboard',
    goodMorning: 'God morgen',
    goodAfternoon: 'God ettermiddag',
    goodEvening: 'God kveld',
    lastLogin: 'Siste innlogging',
    infrastructure: 'Infrastruktur',
    transportAssets: 'Transportressurser',
    treatmentFacilities: 'Behandlingsinstitusjoner',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Forespørselsstatistikk',
    viewAllRequests: 'Se alle forespørsler',
    availableAssets: 'Tilgjengelige Ressurser',
    seated: 'Sittende',
    lying: 'Liggende',
    intensive: 'Intensiv',
    notifications: 'Varsler',
    markAllRead: 'Marker alle som lest',
    noNotifications: 'Ingen varsler ennå',
    notifiedWhenActivity: 'Du vil bli varslet når det er ny aktivitet',
    viewDetailsBtn: 'Se Detaljer',
    nationUsers: 'Nasjonsbrukere',
    user: 'Bruker',
    roles: 'Roller',
    noUsersFound: 'Ingen brukere funnet',
    participatingNations: 'Deltakende Nasjoner',
    exerciseDisclaimer: 'Dette systemet er kun til øvelsesbruk. Legg kun inn simulerte øvelsesdata. Arbeidsflyten er tilpasset øvelsesscenariet og kan avvike fra virkelige prosedyrer. Regler for IT-sikkerhet og personvern gjelder fullt ut.',
    notConfigured: 'Ikke konfigurert',
    requestCount: '{{count}} forespørsel(er)',
    clickToView: 'Klikk for å se',
    systemAdministration: 'Systemadministrasjon',
    exerciseControlTitle: 'Øvelsesstyring',
    euCoordination: 'EU-koordinering',
    transportPlanningTitle: 'Transportplanlegging',
    hubManagement: 'Hub-styring',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Ny Forespørsel',
    myDrafts: 'Mine Utkast',
    pendingReview: 'Venter på Gjennomgang',
    activeTransports: 'Aktive Transporter',
    myPatients: 'Mine Pasienter',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Forespørsler',
    newRequest: 'Ny Forespørsel',
    createRequest: 'Opprett Forespørsel',
    editRequest: 'Rediger Forespørsel',
    requestDetail: 'Forespørselsdetalj',
    requestId: 'Forespørsels-ID',
    fromNation: 'Fra Nasjon',
    toNation: 'Til Nasjon',
    requestingNation: 'Forespørrende Nasjon',
    receivingNation: 'Mottakende Nasjon',
    category: 'Kategori',
    urgency: 'Hastegrad',
    status: 'Status',
    patients: 'Pasienter',
    patientCount: 'Antall Pasienter',
    offers: 'Tilbud',
    offerCount: 'Antall Tilbud',
    created: 'Opprettet',
    updated: 'Oppdatert',
    submittedBy: 'Innsendt av',
    reviewedBy: 'Gjennomgått av',
    description: 'Beskrivelse',
    medicalDetails: 'Medisinske Detaljer',
    transportDetails: 'Transportdetaljer',
    additionalInfo: 'Tilleggsinformasjon',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Avgangspunkt',
    arrivalPoint: 'Ankomstpunkt',
    estimatedDeparture: 'Forventet Avgang',
    estimatedArrival: 'Forventet Ankomst',
    submitForReview: 'Send inn til Gjennomgang',
    publish: 'Publiser',
    startSelection: 'Start Utvelgelse',
    acceptOffer: 'Aksepter Tilbud',
    markInTransit: 'Marker Under Transport',
    markCompleted: 'Marker Fullført',
    closeRequest: 'Lukk Forespørsel',
    withdrawRequest: 'Trekk Tilbake Forespørsel',
    withdraw: 'Trekk Tilbake',
    revertToDraft: 'Tilbakestill til Utkast',
    deleteRequest: 'Slett Forespørsel',
    duplicateRequest: 'Dupliser Forespørsel',
    createFollowUp: 'Opprett konsolidert forespørsel',
    followUpRequest: 'Konsolidert forespørsel',
    parentRequest: 'Opprinnelig forespørsel',
    childRequests: 'Konsoliderte forespørsler',
    noRequests: 'Ingen forespørsler funnet',
    noOffers: 'Ingen tilbud ennå',
    addPatient: 'Legg til Pasient',
    removePatient: 'Fjern Pasient',
    patientDetails: 'Pasientdetaljer',
    contactPerson: 'Kontaktperson',
    contactPhone: 'Kontakttelefon',
    contactEmail: 'Kontakt-e-post',
    specialRequirements: 'Spesielle Krav',
    medicalEquipment: 'Medisinsk Utstyr',
    accompaniment: 'Ledsagelse',
    timeline: 'Tidslinje',
    history: 'Historikk',
    addComment: 'Legg til Kommentar',
    writeComment: 'Skriv en kommentar...',
    postComment: 'Send Kommentar',
    posting: 'Sender...',
    noComments: 'Ingen kommentarer ennå',
    coverageBar: 'Dekning',
    covered: 'dekket',
    uncovered: 'udekket',
    filterByStatus: 'Filtrer etter status',
    filterByCategory: 'Filtrer etter kategori',
    filterByNation: 'Filtrer etter nasjon',
    searchRequests: 'Søk i forespørsler...',
    confirmWithdraw: 'Er du sikker på at du vil trekke tilbake denne forespørselen?',
    confirmDelete: 'Er du sikker på at du vil slette denne forespørselen?',
    confirmPublish: 'Er du sikker på at du vil publisere denne forespørselen? Den vil bli synlig for alle nasjoner.',
    confirmStartSelection: 'Er du sikker på at du vil starte utvelgelsen? Nasjoner vil kunne gi tilbud.',
    warningStartSelection: 'Å starte utvelgelsen vil gjøre denne forespørselen synlig for alle deltakende nasjoner. De vil kunne sende inn tilbud for pasientene i denne forespørselen. Denne handlingen kan ikke angres.',
    warningMakeOffer: 'Ved å sende inn dette tilbudet forplikter du din nasjon til å yte den foreslåtte bistanden. Denne handlingen vil varsle den forespørrende nasjonen og øvelsesstyringen.',
    saveDraft: 'Lagre Utkast',
    saving: 'Lagrer...',
    saveAndSubmit: 'Lagre og Send inn',
    step: 'Trinn {{number}}',
    generalInfo: 'Generell Informasjon',
    patientInfo: 'Pasientinformasjon',
    logisticsInfo: 'Logistikkinformasjon',
    reviewSubmit: 'Gjennomgå og Send inn',
    requestTitle: 'Forespørselstittel',
    requestDescription: 'Forespørselsbeskrivelse',
    numberOfPatients: 'Antall Pasienter',
    typeOfAssistance: 'Type Bistand',
    medicalTreatment: 'Medisinsk Behandling',
    transportAssistance: 'Transportbistand',
    both: 'Begge',
    treatmentOnly: 'Kun Behandling',
    transportOnly: 'Kun Transport',
    validationErrors: 'Vennligst rett følgende feil:',
    fieldRequired: 'Dette feltet er påkrevd',
    selectExitHub: 'Velg en utgangshub',
    createExitHub: 'Opprett Utgangshub',
    backToRequests: 'Tilbake til Forespørsler',
    noRequestsFound: 'Ingen forespørsler funnet',
    createFirstRequest: 'Opprett din første forespørsel for å komme i gang',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Tilbud',
    createOffer: 'Opprett Tilbud',
    makeOffer: 'Gi Tilbud',
    manageOffers: 'Administrer Tilbud',
    offerDetail: 'Tilbudsdetalj',
    offerId: 'Tilbuds-ID',
    offeringNation: 'Tilbydende Nasjon',
    offerType: 'Tilbudstype',
    treatment: 'Behandling',
    transport: 'Transport',
    combined: 'Kombinert',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Behandlingstilbud',
    transportOffer: 'Transporttilbud',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Velg Pasienter',
    selectedPatients: 'Valgte Pasienter',
    patientSelection: 'Pasientutvelgelse',
    offerConfiguration: 'Tilbudskonfigurasjon',
    reviewOffer: 'Gjennomgå Tilbud',
    submitOffer: 'Send inn Tilbud',
    submitting: 'Sender inn...',
    acceptOffer: 'Aksepter Tilbud',
    rejectOffer: 'Avvis Tilbud',
    withdrawOffer: 'Trekk Tilbud Tilbake',
    noOffers: 'Ingen tilbud tilgjengelige',
    noOffer: 'No Offer',
    offerStatus: 'Tilbudsstatus',
    offerDate: 'Tilbudsdato',
    transportAsset: 'Transportressurs',
    departureDate: 'Avgangsdato',
    arrivalDate: 'Ankomstdato',
    treatmentFacility: 'Behandlingsinstitusjon',
    capacity: 'Kapasitet',
    availableCapacity: 'Tilgjengelig Kapasitet',
    totalCapacity: 'Total Kapasitet',
    selectAsset: 'Velg Ressurs',
    selectFacility: 'Velg Institusjon',
    offerNotes: 'Tilbudsnotater',
    confirmAccept: 'Er du sikker på at du vil akseptere dette tilbudet?',
    confirmReject: 'Er du sikker på at du vil avvise dette tilbudet?',
    extendTransport: 'Forleng Transport',
    transportExtension: 'Transportforlengelse',
    comparisonView: 'Sammenligningsvisning',
    shortlist: 'Shortlist',
    addToShortlist: 'Legg til Shortlist',
    removeFromShortlist: 'Fjern fra Shortlist',
    leaveConfirmTitle: 'Forlate denne siden?',
    leaveConfirmMessage: 'Du har ulagrede endringer. Er du sikker på at du vil forlate siden?',
    stayOnPage: 'Bli på Siden',
    leavePage: 'Forlat Siden',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transporter',
    missionDetail: 'Transportdetalj',
    missionId: 'Transport-ID',
    missionStatus: 'Transportstatus',
    createMission: 'Opprett Transport',
    overview: 'Oversikt',
    patientsTab: 'Pasienter',
    transportsTab: 'Transportetapper',
    treatmentTab: 'Behandling',
    reviewTab: 'Gjennomgang',
    departure: 'Avgang',
    arrival: 'Ankomst',
    origin: 'Opprinnelse',
    destination: 'Destinasjon',
    stops: 'Stopp',
    addStop: 'Legg til Stopp',
    removeStop: 'Fjern Stopp',
    stopName: 'Stoppnavn',
    stopType: 'Stopptyp',
    estimatedTime: 'Forventet Tid',
    actualTime: 'Faktisk Tid',
    asset: 'Ressurs',
    driver: 'Sjåfør',
    crew: 'Mannskap',
    noMissions: 'Ingen transporter funnet',
    completeMission: 'Fullfør Transport',
    cancelMission: 'Avlys Transport',
    startTransport: 'Start Transport',
    missionChain: 'Transportkjede',
    linkedMissions: 'Tilknyttede Transporter',
    handover: 'Overlevering',
    handoverPoint: 'Overleveringspunkt',
    pickupPoint: 'Hentepunkt',
    dropoffPoint: 'Leveringspunkt',
    searchTransports: 'Søk i transporter...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pasienter',
    myPatients: 'Mine Pasienter',
    patientId: 'Pasient-ID',
    firstName: 'Fornavn',
    lastName: 'Etternavn',
    dateOfBirth: 'Fødselsdato',
    age: 'Alder',
    gender: 'Kjønn',
    male: 'Mann',
    female: 'Kvinne',
    other: 'Annet',
    nationality: 'Nasjonalitet',
    diagnosis: 'Diagnose',
    condition: 'Tilstand',
    stable: 'Stabil',
    critical: 'Kritisk',
    serious: 'Alvorlig',
    treatmentNeeded: 'Behandling Nødvendig',
    allergies: 'Allergier',
    medications: 'Medisiner',
    bloodType: 'Blodtype',
    weight: 'Vekt (kg)',
    infectious: 'Smittsom',
    mentalHealth: 'Psykisk Helse',
    mobility: 'Mobilitet',
    ambulatory: 'Oppegående',
    wheelchair: 'Rullestol',
    stretcher: 'Båre',
    intensive: 'Intensivbehandling',
    oxygenRequired: 'Oksygenbehov',
    ventilator: 'Respirator',
    medicalEscort: 'Medisinsk Eskorte',
    noPatients: 'Ingen pasienter funnet',
    patientDetails: 'Pasientdetaljer',
    medicalHistory: 'Sykehistorikk',
    travelDocuments: 'Reisedokumenter',
    passport: 'Pass',
    pseudonymizedId: 'Pseudonymisert ID',
    sensitiveData: 'Sensitive Data',
    journey: 'Pasientforløp',
    assignedTo: 'Tildelt til',
    currentLocation: 'Nåværende Plassering',
    importPatients: 'Importer Pasienter',
    exportPatients: 'Eksporter Pasienter',
    seated: 'Sittende',
    lying: 'Liggende',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Brukere',
    createUser: 'Opprett Bruker',
    editUser: 'Rediger Bruker',
    deleteUser: 'Slett Bruker',
    username: 'Brukernavn',
    displayName: 'Visningsnavn',
    email: 'E-post',
    password: 'Passord',
    role: 'Rolle',
    roles: 'Roller',
    nation: 'Nasjon',
    active: 'Aktiv',
    lastLogin: 'Siste Innlogging',
    createdAt: 'Opprettet',
    isNation: 'Nasjon',
    isEU: 'EU',
    isAdmin: 'Admin',
    isExcon: 'EXCON',
    isPlanner: 'Planlegger',
    isHub: 'Hub',
    isReadOnly: 'Skrivebeskyttet',
    noUsers: 'Ingen brukere funnet',
    confirmDelete: 'Er du sikker på at du vil slette denne brukeren?',
    resetPassword: 'Tilbakestill Passord',
    generatePassword: 'Generer Passord',
    searchUsers: 'Søk i brukere...',
    userCreated: 'Bruker opprettet vellykket',
    userUpdated: 'Bruker oppdatert vellykket',
    userDeleted: 'Bruker slettet vellykket',
    selectNation: 'Velg en nasjon',
    mustChangePassword: 'Må endre passord ved neste innlogging',
    flagImage: 'Flaggbilde',
    exportUsers: 'Eksporter Brukere',
    importUsers: 'Importer Brukere',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Ressurser',
    createAsset: 'Opprett Ressurs',
    editAsset: 'Rediger Ressurs',
    deleteAsset: 'Slett Ressurs',
    assetName: 'Ressursnavn',
    assetType: 'Ressurstype',
    capacitySeated: 'Kapasitet (Sittende)',
    capacityLying: 'Kapasitet (Liggende)',
    capacityIntensive: 'Kapasitet (Intensiv)',
    owner: 'Eier',
    operator: 'Operatør',
    baseLocation: 'Basisplassering',
    range: 'Rekkevidde',
    speed: 'Hastighet',
    noAssets: 'Ingen ressurser funnet',
    confirmDelete: 'Er du sikker på at du vil slette denne ressursen?',
    searchAssets: 'Søk i ressurser...',
    assetCreated: 'Ressurs opprettet vellykket',
    assetUpdated: 'Ressurs oppdatert vellykket',
    assetDeleted: 'Ressurs slettet vellykket',
    exportAssets: 'Eksporter Ressurser',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Hubber',
    startPoints: 'Startpunkter',
    createHub: 'Opprett Hub',
    editHub: 'Rediger Hub',
    deleteHub: 'Slett Hub',
    hubName: 'Hub-navn',
    hubType: 'Hub-type',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Inngangshub',
    airport: 'Flyplass',
    seaport: 'Havn',
    railStation: 'Togstasjon',
    roadPoint: 'Veipunkt',
    ucpmClassification: 'UCPM-klassifisering',
    icaoCode: 'ICAO-kode',
    iataCode: 'IATA-kode',
    noHubs: 'Ingen hubber funnet',
    confirmDelete: 'Er du sikker på at du vil slette denne hubben?',
    searchHubs: 'Søk i hubber...',
    nationAssignment: 'Nasjonstildeling',
    assignNations: 'Tildel Nasjoner',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Behandlingsinstitusjoner',
    createFacility: 'Opprett Institusjon',
    editFacility: 'Rediger Institusjon',
    deleteFacility: 'Slett Institusjon',
    facilityName: 'Institusjonsnavn',
    facilityType: 'Institusjonstype',
    hospitalName: 'Sykehusnavn',
    bedCapacity: 'Sengekapasitet',
    specialties: 'Spesialiteter',
    availableBeds: 'Tilgjengelige Senger',
    totalBeds: 'Senger Totalt',
    contactPerson: 'Kontaktperson',
    noFacilities: 'Ingen behandlingsinstitusjoner funnet',
    confirmDelete: 'Er du sikker på at du vil slette denne institusjonen?',
    searchFacilities: 'Søk i institusjoner...',
    hubNationAssignment: 'Hub-nasjonstildeling',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Ruteplaner',
    createSchedule: 'Opprett Ruteplan',
    editSchedule: 'Rediger Ruteplan',
    deleteSchedule: 'Slett Ruteplan',
    scheduleName: 'Ruteplannavn',
    scheduleType: 'Ruteplantype',
    recurring: 'Gjentakende',
    oneTime: 'Engangs',
    frequency: 'Frekvens',
    daily: 'Daglig',
    weekly: 'Ukentlig',
    startDate: 'Startdato',
    endDate: 'Sluttdato',
    departureTime: 'Avgangstid',
    arrivalTime: 'Ankomsttid',
    stops: 'Stopp',
    addStop: 'Legg til Stopp',
    noSchedules: 'Ingen ruteplaner funnet',
    bookings: 'Bookinger',
    timeline: 'Tidslinje',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Varsler',
    markAllRead: 'Marker alle som lest',
    markAsRead: 'Marker som lest',
    markAsUnread: 'Marker som ulest',
    noNotifications: 'Ingen varsler',
    viewAll: 'Se Alle Varsler',
    settings: 'Varselinnstillinger',
    emailNotifications: 'E-postvarsler',
    inAppNotifications: 'In-app-varsler',
    notifyOn: 'Varsle meg om',
    requestCreated: 'Ny Forespørsel',
    requestPublished: 'Forespørsel Publisert',
    requestClosed: 'Forespørsel Lukket',
    requestCompleted: 'Forespørsel Fullført',
    commentAdded: 'Ny Kommentar',
    offerReceived: 'Tilbud Mottatt',
    offerAccepted: 'Tilbud Akseptert',
    statusChanged: 'Status Endret',
    selectionStarted: 'Utvelgelse Startet',
    missionCreated: 'Transport Opprettet',
    missionStatusUpdated: 'Transport Oppdatert',
    transportPartnerNamed: 'Transportpartner',
    transportExtensionReceived: 'Transportforlengelse',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Innstillinger',
    general: 'Generelt',
    system: 'System',
    email: 'E-post',
    sync: 'Synkronisering',
    security: 'Sikkerhet',
    appearance: 'Utseende',
    systemName: 'Systemnavn',
    systemEmail: 'System-e-post',
    maintenanceMode: 'Vedlikeholdsmodus',
    readOnlyMode: 'Skrivebeskyttet Modus',
    emailEnabled: 'E-post Aktivert',
    smtpHost: 'SMTP-server',
    smtpPort: 'SMTP-port',
    smtpUser: 'SMTP-bruker',
    smtpPassword: 'SMTP-passord',
    senderEmail: 'Avsender-e-post',
    senderName: 'Avsendernavn',
    testEmail: 'Send Test-e-post',
    syncEnabled: 'Synkronisering Aktivert',
    syncUrl: 'Synkroniserings-URL',
    syncApiKey: 'Synkroniserings-API-nøkkel',
    settingsSaved: 'Innstillinger lagret vellykket',
    helpdesk: 'Helpdesk',
    helpdeskTitle: 'Helpdesk-tittel',
    helpdeskEmail: 'Helpdesk-e-post',
    helpdeskPhone: 'Helpdesk-telefon',
    helpdeskInfo: 'Helpdesk-informasjon',
    realLifeSupport: 'Støtte i Virkeligheten',
    trainingMode: 'Treningsmodus',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Revisjonslogger',
    action: 'Handling',
    user: 'Bruker',
    target: 'Mål',
    details: 'Detaljer',
    timestamp: 'Tidsstempel',
    ipAddress: 'IP-adresse',
    noLogs: 'Ingen revisjonslogger funnet',
    searchLogs: 'Søk i logger...',
    filterByAction: 'Filtrer etter handling',
    filterByUser: 'Filtrer etter bruker',
    exportLogs: 'Eksporter Logger',
    exportCsv: 'Eksporter CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Øvelsesstyring',
    currentDay: 'Nåværende Dag',
    exerciseDay: 'Øvelsesdag',
    nextDay: 'Neste Dag',
    previousDay: 'Forrige Dag',
    resetExercise: 'Tilbakestill Øvelse',
    startExercise: 'Start Øvelse',
    endExercise: 'Avslutt Øvelse',
    dayReset: 'Dagstilbakestilling',
    confirmReset: 'Er du sikker på at du vil tilbakestille øvelsesdagen? Dette vil slette alle data for gjeldende dag.',
    resetInProgress: 'Tilbakestilling pågår...',
    maintenanceMode: 'Vedlikeholdsmodus',
    enableMaintenance: 'Aktiver Vedlikehold',
    disableMaintenance: 'Deaktiver Vedlikehold',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Datasynkronisering',
    syncStatus: 'Synkroniseringsstatus',
    lastSync: 'Siste Synkronisering',
    pendingItems: 'Ventende Elementer',
    syncNow: 'Synkroniser Nå',
    syncing: 'Synkroniserer...',
    syncSuccess: 'Synkronisering fullført vellykket',
    syncFailed: 'Synkronisering mislyktes',
    outbox: 'Utboks',
    inbox: 'Innboks',
    configuration: 'Konfigurasjon',
    targetUrl: 'Mål-URL',
    apiKey: 'API-nøkkel',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Kart',
    layers: 'Lag',
    requests: 'Forespørsler',
    hubs: 'Hubber',
    facilities: 'Institusjoner',
    routes: 'Ruter',
    showAll: 'Vis Alle',
    hideAll: 'Skjul Alle',
    zoomIn: 'Zoom Inn',
    zoomOut: 'Zoom Ut',
    resetView: 'Tilbakestill Visning',
    satellite: 'Satellitt',
    terrain: 'Terreng',
    offline: 'Frakoblet',
    online: 'Tilkoblet',
    tilesOffline: 'Kartfliser betjenes lokalt',
    tilesOnline: 'Kartfliser lastes fra nettservere',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistikk',
    overview: 'Oversikt',
    requestsByStatus: 'Forespørsler etter Status',
    requestsByCategory: 'Forespørsler etter Kategori',
    requestsByNation: 'Forespørsler etter Nasjon',
    offersByStatus: 'Tilbud etter Status',
    patientsByCondition: 'Pasienter etter Tilstand',
    transportsByStatus: 'Transporter etter Status',
    timeline: 'Tidslinje',
    totalRequests: 'Forespørsler Totalt',
    totalOffers: 'Tilbud Totalt',
    totalPatients: 'Pasienter Totalt',
    totalTransports: 'Transporter Totalt',
    averageResponseTime: 'Gjennomsnittlig Svartid',
    completionRate: 'Fullføringsrate',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Øvelsesstatistikk',
    overview: 'Oversikt',
    byCategory: 'Etter Kategori',
    byNation: 'Etter Nasjon',
    byDay: 'Etter Dag',
    totalPatientsMoved: 'Pasienter Flyttet Totalt',
    totalRequestsProcessed: 'Forespørsler Behandlet Totalt',
    averageProcessingTime: 'Gjennomsnittlig Behandlingstid',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Flytdiagram',
    sankey: 'Sankey',
    nodeGraph: 'Nodegraf',
    refresh: 'Oppdater',
    noData: 'Ingen flytdata tilgjengelig',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Om',
    version: 'Versjon',
    systemInfo: 'Systeminformasjon',
    buildDate: 'Byggedato',
    environment: 'Miljø',
    description: 'ARCOS — Avansert Forespørselskommunikasjonssystem',
    subtitle: 'Pårørendebistand og Medisinske Operasjoner',
    whatIsArcos: 'Hva er ARCOS? – Forklaring for øvelsesdeltakere',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'Tilrettelagt av MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – hvor nysgjerrighet møter samarbeid.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentasjon',
    gettingStarted: 'Kom i Gang',
    userGuide: 'Brukerveiledning',
    faq: 'Ofte Stilte Spørsmål',
    troubleshooting: 'Feilsøking',
    apiReference: 'API-referanse',
    downloadTemplate: 'Last ned Mal',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Pasientimport',
    uploadFile: 'Last opp Fil',
    selectFile: 'Velg Fil',
    preview: 'Forhåndsvisning',
    importNow: 'Importer Nå',
    importing: 'Importerer...',
    importSuccess: '{{count}} pasienter importert vellykket',
    importFailed: 'Import mislyktes',
    downloadTemplate: 'Last ned Mal',
    dragDrop: 'Dra og slipp en fil her, eller klikk for å velge',
    supportedFormats: 'Støttede formater: XLSX, XLS, CSV',
    rowsFound: '{{count}} rader funnet',
    validRows: '{{count}} gyldige rader',
    invalidRows: '{{count}} ugyldige rader',
    duplicateRows: '{{count}} duplikerte rader',
    previewData: 'Forhåndsvis Data',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Transportplanlegging',
    planRoute: 'Planlegg Rute',
    routeBuilder: 'Rutebygger',
    addWaypoint: 'Legg til Mellompunkt',
    removeWaypoint: 'Fjern Mellompunkt',
    estimatedDuration: 'Forventet Varighet',
    distance: 'Avstand',
    selectVehicle: 'Velg Kjøretøy',
  },

  transportBooking: {
    title: 'Transportbooking',
    bookTransport: 'Book Transport',
    availableSlots: 'Tilgjengelige Plasser',
    bookingConfirmed: 'Booking Bekreftet',
    cancelBooking: 'Avbestill Booking',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Kapasitetsplanlegging',
    totalCapacity: 'Total Kapasitet',
    usedCapacity: 'Brukt Kapasitet',
    availableCapacity: 'Tilgjengelig Kapasitet',
    utilizationRate: 'Utnyttelsesgrad',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Ressursmaler',
    dayTemplates: 'Dagsmaler',
    createTemplate: 'Opprett Mal',
    editTemplate: 'Rediger Mal',
    deleteTemplate: 'Slett Mal',
    templateName: 'Malnavn',
    applyTemplate: 'Bruk Mal',
    noTemplates: 'Ingen maler funnet',
    confirmDelete: 'Er du sikker på at du vil slette denne malen?',
    confirmApply: 'Er du sikker på at du vil bruke denne malen? Dette vil overskrive eksisterende data.',
    exportTemplates: 'Eksporter Maler',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Kunngjøringslinje',
    createAnnouncement: 'Opprett Kunngjøring',
    editAnnouncement: 'Rediger Kunngjøring',
    deleteAnnouncement: 'Slett Kunngjøring',
    message: 'Melding',
    startTime: 'Starttid',
    endTime: 'Sluttid',
    active: 'Aktiv',
    noAnnouncements: 'Ingen kunngjøringer',
    confirmDelete: 'Er du sikker på at du vil slette denne kunngjøringen?',
  },

  // ============================================================
  // COMPONENTS — Gjenbrukbare komponenttekster
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Søk...',
      noResults: 'Ingen resultater funnet',
      showing: 'Viser {{from}} til {{to}} av {{total}}',
      rowsPerPage: 'Rader per side',
      previousPage: 'Forrige side',
      nextPage: 'Neste side',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Bekreft',
      cancel: 'Avbryt',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Ulagrede Endringer',
      message: 'Du har ulagrede endringer. Er du sikker på at du vil forlate denne siden?',
      stay: 'Bli på Siden',
      leave: 'Forlat Siden',
    },
    // EmptyState
    emptyState: {
      noData: 'Ingen data tilgjengelig',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Noe gikk galt',
      message: 'En uventet feil oppstod. Vennligst prøv å laste siden på nytt.',
      retry: 'Prøv Igjen',
    },
    // ExportButton
    exportButton: {
      export: 'Eksporter',
      exporting: 'Eksporterer...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Skriv ut',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Utkast',
      review: 'Gjennomgang',
      published: 'Publisert',
      selection: 'Utvelgelse',
      inTransit: 'Under Transport',
      completed: 'Fullført',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Nettinstans',
      message: 'Skrivebeskyttet modus. Data synkroniseres fra den primære serveren.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Du ser som',
      loggedInAs: 'logget inn som {{nation}}',
      returnTo: 'Gå tilbake til {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Søk i sider, forespørsler, transporter...',
      searching: 'Søker...',
      noResults: 'Ingen resultater for "{{query}}"',
      navigate: 'Naviger',
      select: 'Velg',
      close: 'Lukk',
      pages: {
        dashboard: 'Dashboard',
        requests: 'Forespørsler',
        transports: 'Transporter',
        map: 'Kart',
        myPatients: 'Mine Pasienter',
        flowDiagram: 'Flytdiagram',
        statistics: 'Statistikk',
        assets: 'Ressurser',
        startPoints: 'Startpunkter / Hubber',
        treatmentFacilities: 'Behandlingsinstitusjoner',
        users: 'Brukere',
        settings: 'Innstillinger',
        auditLogs: 'Revisjonslogger',
        exerciseControl: 'Øvelsesstyring',
        dataSync: 'Datasynkronisering',
        patientImport: 'Pasientimport',
        notifications: 'Varsler',
        documentation: 'Dokumentasjon',
      },
      actions: {
        importPatientsJson: 'Importer Pasienter (JSON)',
        importPatientsExcel: 'Importer Pasienter (Excel)',
        importUsers: 'Importer Brukere (Excel)',
        importAssetTemplates: 'Importer Eiendelsmaler (Excel)',
        importDayTemplates: 'Importer Dagsmalposter (Excel)',
        exportRequests: 'Eksporter Forespørsler (Excel)',
        exportPatients: 'Eksporter Pasienter (Excel)',
        exportUsers: 'Eksporter Brukere (Excel)',
        exportCredentials: 'Eksporter Påloggingsinformasjon (PDF)',
        exportAuditExcel: 'Eksporter Revisjonslogg (Excel)',
        exportAuditPdf: 'Eksporter Revisjonslogg (PDF)',
        pagePatientImport: 'Side for pasientimport',
        pageRequestDetail: 'Side for forespørselsdetaljer',
        pageUsers: 'Side for brukerstyring',
        pageAssetTemplates: 'Side for eiendelsmaler',
        pageDayTemplates: 'Side for dagsmaler',
        pageRequests: 'Side for forespørselsliste',
        pageAuditLogs: 'Side for revisjonslogg',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sesjonen Utløper',
      message: 'Sesjonen din utløper om <strong>{{time}}</strong>. Vennligst lagre arbeidet ditt og logg inn igjen for å fortsette.',
      dismiss: 'Avvis',
      logoutNow: 'Logg Ut Nå',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Velg 4 tidssoner',
      configure: 'Konfigurer tidssoner',
      reset: 'Tilbakestill',
      apply: 'Bruk',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Velg Plassering',
      latitude: 'Breddegrad',
      longitude: 'Lengdegrad',
      clickToSelect: 'Klikk på kartet for å velge en plassering',
    },
    // Modal
    modal: {
      close: 'Lukk',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Hjem',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Systemvedlikehold',
    message: 'Systemet tilbakestilles for neste øvelsesdag. Vennligst vent til prosessen er fullført.',
    autoRefresh: 'Denne siden oppdateres automatisk når systemet er tilgjengelig igjen.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Minst 10 tegn',
    uppercase: '1 stor bokstav',
    lowercase: '1 liten bokstav',
    digit: '1 siffer',
    special: '1 spesialtegn',
  },
};

export default no;
